export type SyncFailureKind = "network" | "device_setup" | "storage" | "integrity" | "unknown";

export function syncFailureKindFromError(error: unknown): SyncFailureKind {
  const message = error instanceof Error ? error.message : "";

  if (/校验|完整性|哈希|ciphertext|sha256|深度资源格式|解密/i.test(message)) return "integrity";
  if (/本机|持久|存储|indexeddb|sqlite|quota|disk/i.test(message)) return "storage";
  if (/设备|密钥|加密准备|supabase 尚未配置|storageReady/i.test(message)) return "device_setup";
  if (/network|fetch|timeout|offline|internet|连接|网络|http/i.test(message)) return "network";
  return "unknown";
}

export function syncFailureHint(kind: SyncFailureKind) {
  switch (kind) {
    case "network":
      return "网络连接不稳定，恢复联网后会自动重试。";
    case "device_setup":
      return "这台设备或成员设备还在完成安全准备，请保持登录并联网片刻。";
    case "storage":
      return "本机安全存储暂时不可用，请检查设备可用空间后重试。";
    case "integrity":
      return "收到的数据未通过完整性校验，系统不会保存它，并会在下次检查时重新获取。";
    case "unknown":
      return "同步暂时未完成，系统会在网络恢复或下一次检查时重试。";
  }
}
